<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        v-for="analysisRequest in displayedAnalysisRequests"
        :key="analysisRequest.id"
        xl="4"
        lg="4"
        md="6"
        sm="12"
        xs="12"
      >
        <AnalysisRequestCard
          :analysisRequest="analysisRequest"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import AnalysisRequestCard from '@/components/services/AnalysisRequestCard.vue';

export default {
    components: {
        AnalysisRequestCard,
    },
    props: {
        componentId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters([
            'analysisRequests',
        ]),
        displayedAnalysisRequests() {
            return this.analysisRequests.filter(analysisRequest => analysisRequest.component.id === this.componentId);
        },
    },
};
</script>
